
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSilenceIec as ObiSilenceIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-silence-iec.js';
 
 
 

 
 export const ObiSilenceIec = createComponent({
   react: React,
   tagName: 'obi-silence-iec',
   elementClass: ObiSilenceIecElement,
   events: {
     
   }
  });
 
 